import React from 'react';

const AppUpdateModal = () => (
  <div className="app-update-modal-wrapper">
    <div className="app-update-modal-container">
      <div className="row justify-content-around">
        <div className="col-6">
          <div className="app-update-modal-spinner"></div>
          <h4 className="text-center pt-3">Just a moment, application is updating</h4>
        </div>
      </div>
    </div>
  </div>
);

export { AppUpdateModal };
